import { render, staticRenderFns } from "./ResultGrid.vue?vue&type=template&id=286e7aae&"
import script from "./ResultGrid.vue?vue&type=script&lang=js&"
export * from "./ResultGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports